/**
 * PDF Compressor - /pdf page
 * Auto-selects Screen preset (72 DPI) for maximum compression
 */
import { createApp } from 'vue';
import PdfCompressor from '@/Components/PdfCompressor.vue';
import '@styles/app.css';

createApp(PdfCompressor).mount('#pdf-compressor');
